/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import { useDispatch, useSelector } from 'react-redux';

import { AuctionAcceptCurrentBid } from '@components/modals/auction-accept-current';
import { AuctionBid } from '@components/modals/auction-bid';
import { AuctionCancel } from '@components/modals/auction-cancel';
import { AuctionCreate } from '@components/modals/auction-create';
import { AuctionFinalize } from '@components/modals/auction-finalize';
import { AuctionWithdraw } from '@components/modals/auction-withdraw';
import { BoardCoverEdit } from '@components/modals/board-cover-edit';
import { BoardCreate } from '@components/modals/board-create';
import { BoardDelete } from '@components/modals/board-delete';
import { BoardEdit } from '@components/modals/board-edit';
import { ErrorWarning } from '@components/modals/error-warning';
import { OfferAccept } from '@components/modals/offer-accept';
import { OfferCancel } from '@components/modals/offer-cancel';
import { OfferCreate } from '@components/modals/offer-create';
import { ProfileEdit } from '@components/modals/profile-edit';
import { SwapCancel } from '@components/modals/swap-cancel';
import { SwapCollect } from '@components/modals/swap-collect';
import { SwapConclude } from '@components/modals/swap-conclude';
import { SwapCreate } from '@components/modals/swap-create';
import { SwapSlippage } from '@components/modals/swap-slippage';
import { TokenBurn } from '@components/modals/token-burn';
import { TokenSave } from '@components/modals/token-save';
import { TokenTransfer } from '@components/modals/token-transfer';
import { UserBlock } from '@components/modals/user-block';
import { UserFollowers } from '@components/modals/user-followers';
import { UserFollowing } from '@components/modals/user-following';
import { UserOnboarding } from '@components/modals/user-onboarding';
import { UserReport } from '@components/modals/user-report';
import { WhatsNew } from '@components/modals/whats-new';
import { actions } from '@state/modals';
import { RootState } from '@state/store';

const MODALS = [
  // USER
  { key: 'user-followers', Component: UserFollowers },
  { key: 'user-following', Component: UserFollowing },
  { key: 'user-report', Component: UserReport },
  { key: 'user-block', Component: UserBlock },
  { key: 'user-onboarding', Component: UserOnboarding },
  // MARKET
  { key: 'auction-create', Component: AuctionCreate },
  { key: 'auction-cancel', Component: AuctionCancel },
  { key: 'auction-accept-current', Component: AuctionAcceptCurrentBid },
  { key: 'auction-bid', Component: AuctionBid },
  { key: 'auction-finalize', Component: AuctionFinalize },
  { key: 'auction-withdraw', Component: AuctionWithdraw },
  { key: 'swap-create', Component: SwapCreate },
  { key: 'swap-collect', Component: SwapCollect },
  { key: 'swap-cancel', Component: SwapCancel },
  { key: 'swap-conclude', Component: SwapConclude },
  { key: 'swap-slippage', Component: SwapSlippage },
  { key: 'offer-create', Component: OfferCreate },
  { key: 'offer-cancel', Component: OfferCancel },
  { key: 'offer-accept', Component: OfferAccept },
  { key: 'token-transfer', Component: TokenTransfer },
  { key: 'token-burn', Component: TokenBurn },
  // GENERIC
  { key: 'token-save', Component: TokenSave },
  { key: 'profile-edit', Component: ProfileEdit },
  { key: 'whats-new', Component: WhatsNew },
  { key: 'error-warning', Component: ErrorWarning },
  // BOARDS
  { key: 'board-cover-edit', Component: BoardCoverEdit },
  { key: 'board-create', Component: BoardCreate },
  { key: 'board-delete', Component: BoardDelete },
  { key: 'board-edit', Component: BoardEdit },
];

export function ModalManager() {
  const dispatch = useDispatch();
  const modals = useSelector((state: RootState) => state.modals);

  const handleDialog = (nextDialog: string) => {
    // Radix modal stores the prop before opening to return to after closing
    document.body.style.pointerEvents = 'initial';
    dispatch({ type: actions.MODALS_SET_MODAL, payload: { type: nextDialog } });
  };

  return (
    <>
      {MODALS.map((modal) => {
        if (modals.modal?.type !== modal.key) {
          return null;
        }

        return (
          <modal.Component
            key={modal.key}
            open={modals.modal?.type === modal.key}
            onOpenChange={(value: boolean) => handleDialog(value ? modal.key : 'none')}
            {...modals.modal}
          />
        );
      })}
    </>
  );
}
